import { useAppDispatch } from 'hooks/useAppDispatch';
import {
  setEmailOtpTimestampRedux,
  setSmsOtpTimestampRedux,
} from 'store/otp/otp-slice';
import { Channel, Process } from 'types/otp';
import { setOtpTimestamp } from 'utils/otp-timestamps';

const useResetOtpTimeout = () => {
  const dispatch = useAppDispatch();

  const resetTimestamp = (channel: Channel, process: Process | any) => {
    const reduxAction =
      channel === 'EMAIL' ? setEmailOtpTimestampRedux : setSmsOtpTimestampRedux;
    dispatch(reduxAction({ process, timestamp: null }));
    setOtpTimestamp(channel, process, true);
  };

  return resetTimestamp;
};

export default useResetOtpTimeout;
